export default __webpack_public_path__ + "static/media/snow.2e1d252f.jpg";